export enum CalendarDirection {
    Any,
    TodayPast,
    Past,
    TodayFuture,
    Future,
    AfterMinDate   
}